import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MobileAppService } from '../services/mobile-app.service';

/**
 * Entry point for printed QR codes (`/app`): sends phones and tablets
 * straight to the IsoFarm app store listing and everyone else to the web app.
 */
export const mobileAppStoreRedirectGuard: CanActivateFn = () => {
  const mobileAppService = inject(MobileAppService);
  const platform = mobileAppService.getPlatform();

  if (platform) {
    mobileAppService.redirectToStore(platform);
    return false;
  }
  return inject(Router).parseUrl('/');
};
